// Updated App.js - No major changes, but ensuring dynamic titles and structure
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './screens/Home';
import About from './components/About';
import Programs from './components/Programs';
import Impact from './components/Impact';
import Contact from './components/Contact';
import Donate from './components/Donate';

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'EMA House of Hope | Breaking Poverty Cycles in Zambia',
      '/programs': 'Our Programs | EMA House of Hope',
      '/impact': 'Our Impact | EMA House of Hope',
      '/about': 'About Us | EMA House of Hope',
      '/contact': 'Contact Us | EMA House of Hope',
      '/donate': 'Donate | Support EMA House of Hope',
    };

    document.title = titles[location.pathname] || 'EMA House of Hope';
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-ehh-cream">
        <PageTitle />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;